/* AjouterMaladie.js*/

import React, { useState, useEffect } from "react";
import { Container, Typography, Select, MenuItem, Button, Snackbar, Alert, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../config'; // Assure-toi que ton apiUrl est bien importé
import '../CSS/ajouterdeclarations.css';
import LayoutDashboard from "../layout/LayoutDashboard";

const AjouterMaladie = () => {
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [maladieDays, setMaladieDays] = useState({});
    const [blockedDaysMap, setBlockedDaysMap] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [declarationId, setDeclarationId] = useState(null);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [loading, setLoading] = useState(false);
    const [loadingEditView, setLoadingEditView] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isDaysLoading, setIsDaysLoading] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [initialMaladieDays, setInitialMaladieDays] = useState({});
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [monthAlreadyDeclared, setMonthAlreadyDeclared] = useState(false);
    
const getMaladieBlockedCacheKey = (userId, month, year) => {
    return `blocked_maladie_days_${userId}_${month}_${year}`;
};

const getCachedMaladieBlockedDays = (userId, month, year) => {
    try {
        const cached = sessionStorage.getItem(getMaladieBlockedCacheKey(userId, month, year));
        return cached ? JSON.parse(cached) : null;
    } catch {
        return null;
    }
};

const saveCachedMaladieBlockedDays = (userId, month, year, data) => {
    sessionStorage.setItem(
        getMaladieBlockedCacheKey(userId, month, year),
        JSON.stringify(data)
    );
};

const clearMaladieBlockedCache = (userId, month, year) => {
    sessionStorage.removeItem(getMaladieBlockedCacheKey(userId, month, year));
};

const extractDaysFromDateField = (value, month, year) => {
  if (!value || value === "0") return [];

  return value
    .toString()
    .split("/")
    .map(date => date.trim())
    .filter(Boolean)
    .map(date => new Date(date))
    .filter(date => !Number.isNaN(date.getTime()))
    .filter(date => date.getFullYear() === Number(year) && date.getMonth() + 1 === Number(month))
    .map(date => date.getDate());
};

const getTravailCongeDaysForMaladieTable = async (userId, month, year) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${apiUrl}/declarations/${userId}?fresh=1&t=${Date.now()}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const allDeclarations = response.data || [];
    const blockedDays = new Set();

    allDeclarations.forEach((item) => {
      extractDaysFromDateField(item.Jours_Selectionnes, month, year).forEach((day) => {
        blockedDays.add(day);
      });

      extractDaysFromDateField(item.jours_congé, month, year).forEach((day) => {
        blockedDays.add(day);
      });
    });

    return Array.from(blockedDays);
  } catch (error) {
    console.error("Erreur chargement jours travail/congé à bloquer :", error);
    return [];
  }
};


    useEffect(() => {
  const loadDetails = async () => {
    const token = localStorage.getItem("token");
    const tokenData = JSON.parse(atob(token.split(".")[1]));
    const userIdFromToken = tokenData.user_id;

    let userId = location.state?.selectedUserId || userIdFromToken;
    setSelectedUserId(userId);

    // 👉 Si on modifie une déclaration
    if (location.state?.declarationId) {
      setIsEditMode(true);
      setDeclarationId(location.state.declarationId);

      setIsDaysLoading(true); // ✅ Affiche immédiatement le message

      try {
        const response = await axios.get(`${apiUrl}/maladies/${location.state.declarationId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.status === 200) {
          const declaration = response.data;
          const maladieArray = declaration.jours_maladie && declaration.jours_maladie !== "0"
            ? declaration.jours_maladie
              .split("/  ")
              .map(date => date.trim())
              .filter(Boolean)
            : [];

          const maladieObj = {};
          maladieArray.forEach(dateStr => {
  const d = new Date(dateStr);
  const day = d.getDate();
  maladieObj[day] = 1;
});

          setInitialMaladieDays(maladieObj);
          setMaladieDays(maladieObj);
          setInitialLoaded(true);

          let extractedMonth = location.state?.selectedMonth;
          let extractedYear = location.state?.selectedYear;

          if (!extractedMonth && maladieArray.length > 0) {
            const firstDate = new Date(maladieArray[0]);
            extractedMonth = firstDate.getMonth() + 1;
            extractedYear = firstDate.getFullYear();
          }

          if (extractedMonth && extractedYear) {
            setSelectedMonth(extractedMonth);
            setSelectedYear(extractedYear);
            await handleMonthChange(extractedMonth, userId, maladieObj, true); // ✅ c’est ici que setIsDaysLoading(false) sera appelé
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des données de maladie:', error);
        setIsDaysLoading(false); // fail-safe
      }
    }
  };

  loadDetails();
}, [location.state]);

//////////////////////

useEffect(() => {
    const chargerJoursMaladie = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${apiUrl}/declarations/${selectedUserId}`, {
        headers: { Authorization: `Bearer ${token}` }
    });

    const joursMaladieTrouvés = {};

    if (response.status === 200) {
        const toutesDeclarations = response.data;

        toutesDeclarations.forEach((decl) => {
            const joursMaladie = decl.jours_maladie;
            if (joursMaladie && joursMaladie !== "0") {
                joursMaladie.split('/').forEach(dateStr => {
                    const date = new Date(dateStr.trim());
                    if (
                        date.getFullYear() === selectedYear &&
                        date.getMonth() + 1 === selectedMonth
                    ) {
                        joursMaladieTrouvés[date.getDate()] = 1;
                    }
                });
            }
        });
    }

    return joursMaladieTrouvés;
};



    if (!isEditMode && selectedMonth && selectedYear && selectedUserId) {
        setIsDaysLoading(true); 
        chargerJoursMaladie().then((jours) => {
    setInitialMaladieDays(jours);
    handleMonthChange(selectedMonth, selectedUserId, jours);
});
    }
}, [selectedMonth, selectedYear, selectedUserId, isEditMode]);



const [monthHandled, setMonthHandled] = useState(false);

  const handleMonthChange = async (input, userIdOverride = null, joursMaladie = null, forceEditMode = false) => {
    const month = typeof input === 'number' ? input : parseInt(input.target.value);

    const effectiveIsEditMode =
    forceEditMode ||
    isEditMode ||
    Boolean(location.state?.declarationId) ||
    Boolean(declarationId);

    if (!effectiveIsEditMode) {
    setSelectedMonth(month);
}

    setIsDaysLoading(true);

    const userIdRaw = userIdOverride || selectedUserId;
    const validUserId = typeof userIdRaw === 'object'
        ? userIdRaw?.id || userIdRaw?.Id_Utilisateur
        : userIdRaw;

    if (!validUserId || !selectedYear || !month) {
        console.warn("handleMonthChange bloqué : ID, année ou mois manquant");
        setIsDaysLoading(false);
        return;
    }

    try {
        const token = localStorage.getItem('token');

        const jours = {};
        const maladieSource = joursMaladie || maladieDays;

        for (const [day, value] of Object.entries(maladieSource)) {
            const dayNumber = parseInt(day, 10);

            if (!Number.isNaN(dayNumber) && dayNumber >= 1 && dayNumber <= 31) {
                jours[dayNumber] = value;
            }
        }

        if (!effectiveIsEditMode && Object.keys(maladieSource).length > 0) {
    const allDaysBlocked = {};
    const totalDays = new Date(selectedYear, month, 0).getDate();

    for (let day = 1; day <= totalDays; day++) {
        allDaysBlocked[day] = "bloqué";
    }

    setMaladieDays({});
    setBlockedDaysMap(allDaysBlocked);
    setMonthAlreadyDeclared(true);

    setNotification({
        open: true,
        message: "Un arrêt maladie existe déjà pour ce mois. Pour ajouter ou corriger des jours, passez par Modifier.",
        severity: "warning"
    });

    return;
}

        // ✅ Très important : pas de cache ici.
        // On recharge toujours les jours bloqués pour éviter les anciens résultats.
        const response = await axios.get(
            `${apiUrl}/maladies/jours-bloques/${validUserId}/${month}/${selectedYear}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );

        const joursBloques = response.data || [];

const travailCongeDaysToBlock = await getTravailCongeDaysForMaladieTable(validUserId, month, selectedYear);

        // ✅ Bloque uniquement les jours déjà déclarés : travail, congé ou maladie.
        for (const jour of joursBloques) {
            const dayNumber = parseInt(jour, 10);

            if (jours[dayNumber] !== 1) {
                jours[dayNumber] = "bloqué";
            }
        }

        for (const jour of travailCongeDaysToBlock) {
            const dayNumber = parseInt(jour, 10);

            if (!Number.isNaN(dayNumber) && jours[dayNumber] !== 1) {
                jours[dayNumber] = "bloqué";
            }
        }

        // ✅ Restaurer les jours maladie déjà sélectionnés en modification
        for (const [day, value] of Object.entries(maladieSource)) {
            const dayNumber = parseInt(day, 10);

            if (!Number.isNaN(dayNumber) && dayNumber >= 1 && dayNumber <= 31) {
                jours[dayNumber] = 1;
            }
        }

        // ✅ Bloquer week-ends et jours fériés
        const daysInMonth = new Date(selectedYear, month, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(selectedYear, month - 1, day);
            const dateStr = date.toLocaleDateString('fr-CA');
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;

            if ((isWeekend || holidays.has(dateStr)) && !(day in jours)) {
                jours[day] = "bloqué";
            }
        }

        setMonthAlreadyDeclared(false);
        setBlockedDaysMap(jours);

    } catch (error) {
        console.error("❌ Erreur lors du chargement des jours bloqués :", error);
    } finally {
        setIsDaysLoading(false);
    }
};
         
    const handleYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedYear(year);
        
    };

    const getDaysInMonth = (year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    };

    const toggleDay = (day) => {

if (blockedDaysMap[day] === "bloqué") return;

if (maladieDays[day] === 1) {
    const newMaladieDays = { ...maladieDays };
    delete newMaladieDays[day];
    setMaladieDays(newMaladieDays);
} else {
    setMaladieDays({ ...maladieDays, [day]: 1 });
}

};  

    const handleMouseDown = (day) => {
        setIsDragging(true);
        toggleDay(day);
    };

    const handleMouseOver = (day) => {
        if (isDragging) {
            toggleDay(day);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
    
            if (!pdfFile) {
                setNotification({ open: true, message: "Veuillez sélectionner un fichier PDF.", severity: 'error' });
                setLoading(false);
                return;
            }
    
            const formattedMaladieDays = Object.keys(maladieDays)
                .filter(day => maladieDays[day] === 1)
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const formData = new FormData();
            formData.append('document', pdfFile); // ✅ le fichier PDF
            formData.append('data', JSON.stringify({ // ✅ les jours de maladie
                maladieDays: formattedMaladieDays,
                Id_Utilisateur: selectedUserId
            }));
    
            const response = await axios.post(`${apiUrl}/maladies`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.status === 200 || response.status === 201) {
                sessionStorage.clear();
                

navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId,
    refreshKey: Date.now()
  }
});
            }            
    
        } catch (error) {
    console.error("Erreur lors de l'ajout :", error);

    if (error.response?.status === 409) {
        setNotification({
            open: true,
            message: error.response.data.message,
            severity: 'warning'
        });
        return;
    }

    setNotification({
        open: true,
        message: "Erreur lors de l’ajout de l’arrêt maladie.",
        severity: 'error'
    });
} finally {
    setLoading(false);
}
    };    
    
   const handleUpdate = async () => {
    try {
        setLoading(true);
        const token = localStorage.getItem('token');

        if (!pdfFile) {
    setNotification({
        open: true,
        message: "Veuillez sélectionner un fichier PDF pour modifier l'arrêt maladie.",
        severity: 'error'
    });
    setLoading(false);
    return;
}

        const formattedMaladieDays = Object.keys(maladieDays)
            .filter(day => maladieDays[day] === 1)
            .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));

        const formData = new FormData();

        if (pdfFile) {
            formData.append('document', pdfFile);
        }

        formData.append('data', JSON.stringify({
    maladieDays: formattedMaladieDays,
    Id_Utilisateur: selectedUserId,
    Id_Declaration: declarationId
}));

        const response = await axios.put(`${apiUrl}/maladies/${declarationId}`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            sessionStorage.clear();
            

navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId,
    refreshKey: Date.now()
  }
});
        }
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'arrêt maladie :", error);

        let errorMessage = "Erreur lors de la mise à jour.";
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        }

        setNotification({
            open: true,
            message: errorMessage,
            severity: 'error'
        });

        // ❌ On ne redirige pas en cas d’erreur
        return;
    } finally {
        setLoading(false);
    }
};
 

    const getFrenchHolidays = (year) => {
        const holidays = new Set([
            `${year}-01-01`, `${year}-05-01`, `${year}-05-08`, `${year}-07-14`, `${year}-08-15`,
            `${year}-11-01`, `${year}-11-11`, `${year}-12-25`
        ]);
        const a = year % 19, b = Math.floor(year / 100), c = year % 100;
        const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        const easter = new Date(year, month - 1, day);
        const easterMonday = new Date(easter); easterMonday.setDate(easter.getDate() + 1);
        const ascensionDay = new Date(easter); ascensionDay.setDate(easter.getDate() + 39);
        const pentecostMonday = new Date(easter); pentecostMonday.setDate(easter.getDate() + 50);
        holidays.add(easter.toLocaleDateString('fr-CA'));
        holidays.add(easterMonday.toLocaleDateString('fr-CA'));
        holidays.add(ascensionDay.toLocaleDateString('fr-CA'));
        holidays.add(pentecostMonday.toLocaleDateString('fr-CA'));
        return holidays;
    };

    const holidays = getFrenchHolidays(selectedYear);

    const isHoliday = (day, month, year, holidays) => {
        if (!month || !year) return false;
        const date = new Date(year, month - 1, day);
        return holidays.has(date.toLocaleDateString('fr-CA'));
    };

    const isWeekend = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        return date.getDay() === 0 || date.getDay() === 6;
    };

    const isToday = (day, month, year) => {
        const today = new Date();
        return day === today.getDate() && month === today.getMonth() + 1 && year === today.getFullYear();
    };

    const daysInMonth = selectedMonth ? getDaysInMonth(selectedYear, selectedMonth) : [];

    return (
        <LayoutDashboard>
        <div className="declarations-add-page" onMouseUp={handleMouseUp}>
    <Container maxWidth="lg" sx={{ p: 0 }}>
                    <div className="header">
                        <Typography variant="h1">
                            {isEditMode ? "Modifier un arrêt maladie" : "Ajouter un arrêt maladie"}
                        </Typography>
                    </div>

                    <div className="month-selector">

<Typography variant="h6" sx={{ color: '#0B349D' }}>
Sélectionner le Mois et l'Année :
</Typography>

<div className="select-row">
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                            <Select value={selectedMonth || ''} onChange={handleMonthChange} displayEmpty variant="outlined" fullWidth sx={{ bgcolor: 'white', borderRadius: '4px' }}>
                                <MenuItem value="" disabled>Choisir un mois</MenuItem>
                                {Array.from({ length: 12 }, (_, index) => (
                                    <MenuItem key={index + 1} value={index + 1}>{new Date(0, index).toLocaleString('default', { month: 'long' })}</MenuItem>
                                ))}
                            </Select>
                            <Select value={selectedYear} onChange={handleYearChange} displayEmpty variant="outlined" fullWidth sx={{ bgcolor: 'white', borderRadius: '4px' }}>
                                {Array.from({ length: 5 }, (_, index) => {
                                    const year = 2025 + index;
                                    return <MenuItem key={year} value={year}>{year}</MenuItem>;
                                })}
                            </Select>
                        </div>
                        </div>
                    </div>

                    {selectedMonth && !isDaysLoading && (
                        <div className="table-wrapper">
    <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th className="main-column">Jours du Mois</th>
                                        {daysInMonth.map(day => {
                                            const isCurrent = isToday(day, selectedMonth, selectedYear);
                                            return (
                                                <th key={day} className="day-column" style={{
                                                    minWidth: '80px',
                                                    backgroundColor: isCurrent ? '#fff2b3' : '',
                                                    color: isCurrent ? 'black' : '',
                                                    fontWeight: isCurrent ? 'bold' : 'normal'
                                                }}>{day}</th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="main-column">Jours de Maladie</td>
                                        {daysInMonth.map(day => {
                                            const isGray = isWeekend(day, selectedMonth, selectedYear) || isHoliday(day, selectedMonth, selectedYear, holidays);
                                           const isBlocked = blockedDaysMap[day] === "bloqué"; // jour déjà déclaré comme travail/congé
                                            const isSelected = maladieDays[day] === 1 || maladieDays[day] === '1';
                                            return (
                                                <td
                                                    key={`maladie-${day}`}
                                                    onMouseDown={() => !isGray && !isBlocked && handleMouseDown(day)}
                                                    onMouseOver={() => !isGray && !isBlocked && handleMouseOver(day)}
                                                    onMouseUp={handleMouseUp}
                                                    style={{
                                                        backgroundColor: isGray || isBlocked ? '#D3D3D3' : isSelected ? '#f28c8c' : '',
                                                        cursor: isGray || isBlocked ? 'not-allowed' : 'pointer',
                                                        minWidth: '80px'
                                                    }}
                                                >
                                                    {maladieDays[day] === 1 ? '1' : ''}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

<Typography variant="h6" sx={{ color: '#0B349D', marginTop: '20px' }}>Fichier d'arrêt maladie (PDF obligatoire) :</Typography>
<input
    type="file"
    accept="application/pdf"
    onChange={(e) => setPdfFile(e.target.files[0])}
/>


                    <div className="actions-row">
                        <Button
className="primary-btn"
onClick={isEditMode ? () => handleUpdate(location.state.declarationId) : handleSubmit}
disabled={loading || (monthAlreadyDeclared && !isEditMode)}
>
                            {isEditMode ? "Valider les modifications" : "Ajouter l'arrêt maladie"}
                        </Button>
                        <Button variant="contained" style={{ backgroundColor: '#1f6391', color: 'white' }}
                           onClick={() => navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId,
    refreshKey: Date.now()
  }
})}>
                            Retourner à la liste
                        </Button>
                    </div>

{isDaysLoading && (
  <div style={{ textAlign: 'center', marginTop: '20px' }}>
    
    <Typography variant="body1">Chargement des jours, merci de patienter...</Typography>
  </div>
)}
                    {loading && (
                        <Snackbar open={true} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={null}>
                            <Alert severity="info" sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                
                                Merci de patienter...
                            </Alert>
                        </Snackbar>
                    )}

<Snackbar
    key={notification.message}
    open={notification.open}
    autoHideDuration={2000} // ⬅️ suffisant pour que onClose soit bien appelé
    onClose={() => {
  setNotification({ ...notification, open: false });
}}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
    <Alert severity={notification.severity} sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', borderRadius: '8px' }}>
        {notification.message}
    </Alert>
</Snackbar>
                </Container>
            </div>
        
        </LayoutDashboard>
    );
};

export default AjouterMaladie;
